$(document).ready(function() {
	var subscriptionsContainer = $('#subscriptions-container'),
		form = $('#subscription-form'),
		validator = form.data('validator');

	var division = form.data('division'),
		category = form.data('category'),
		subscriptionManagerIds = form.data('subscription-management-ids')
			.split(',').filter(function(id) {
                return id.length > 0;
            }).map(function(id) {
				return id.toLowerCase();
			}),
		leadEntityId = form.data('lead-entity-id');

	var submitSuccessUrl = form.data('success-redirect'),
		submitErrUrl = form.data('error-redirect'),
		atLeastOneValidationMsg = form.data('atleastone-validation'),
		submitMsg = newMessageDisplayer($('#messages'));

	var relateInputWithLabel = newInputLabelMapper(),
		getAvailableSubsApi = OnlyLatestRequestCallback(),
		toggleSubmitBtn = GetButtonToggleFn(document.querySelector('#subscription-form button[type="submit"]'));

	// Select/unselect all (global)
	$('#select-unselect-all').change(function(e) {
		var checkbox = e.target,
			isChecked = checkbox.checked;

		// check/uncheck all subscriptions
		subscriptionsContainer
			.find('input[type="checkbox"]')
			.prop('checked', isChecked)
			.change();
	});

	// Unselect all when "Unsubscribe all" or "Never contact me again" are checked
	$('#unsubscribe-all, #never-contact').change(function(e) {
		var checkbox = e.target,
			isChecked = checkbox.checked;

		// uncheck subscriptions if unsubscribe-all is checked
		if (isChecked) {
			subscriptionsContainer
				.find('input[type="checkbox"]')
				.prop('checked', false)
				.change();
		}
	});

	// Select/unselect all (category)
	subscriptionsContainer.on('change', 'input.category-checkbox', function(e) {
		var checkbox = e.target,
			isChecked = checkbox.checked;
		$(checkbox).parent()
			.find('input[type="checkbox"]')
			.prop('checked', isChecked);

		if (isChecked) {
			// uncheck 'Unsubscribe All'
			$('#unsubscribe-all, #never-contact').prop('checked', false);
		} else {
			// uncheck select/unselect all if any checkbox is unselected
			$('#select-unselect-all').prop('checked', false);
		}
	});

	// Subscription option checkboxes
	subscriptionsContainer.on('change', '.subscription-options-container input[type="checkbox"]', function(e) {
		var checkbox = $(e.target),
			isChecked = checkbox.get(0).checked,
			optionContainer = checkbox.parent(),
			categoryCheckbox = optionContainer.parent().find('.category-checkbox');

		if (isChecked) {
			// check category box
			categoryCheckbox.prop('checked', true);

			// uncheck termination checkboxes
			$('#unsubscribe-all').prop('checked', false);
			$('#never-contact').prop('checked', false);
			return;
		}

		// uncheck category if no children are selected
		if(optionContainer.find('input:checked').length == 0) {
			categoryCheckbox.prop('checked', false);
		}

		// uncheck select/unselect all if any checkbox is unselected
		$('#select-unselect-all').prop('checked', false);
	});

	if (validator) {
		validator.settings.submitHandler = submitPreferences;

		// don't ignore captcha-verifier
		validator.settings.ignore = ':hidden:not(#captcha-verifier)';

		// Require at least one subscription when handling 'new subscription signup'
		validator.settings.rules['spray-subscription'] = {
			required: function(value, element, param) {
				return $('#subscriptions-container input:checked').length < 1;
			},
			minlength: 1
		};
		validator.settings.messages['spray-subscription'] = { required: atLeastOneValidationMsg };
	} else {
		// validator will not be available if no [data-val] inputs are in form
        form.submit(function(e) {
            e.preventDefault();
            submitPreferences();
        });
    }

	getAvailableSubscriptions(division, category, subscriptionManagerIds);

	function submitPreferences() {
		var msgContainer = $('#messages');

        toggleSubmitBtn(false, 'form-submit');
		submitMsg(msgContainer.data('submit-msg'));

		$.ajax(leadEntityId
			? getSubmitPreferencesAjaxRequest(
				successCallback = function() {
					submitMsg(msgContainer.data('submit-success-msg'), 10000);
				}, errorCallback = function() {
					submitMsg(msgContainer.data('submit-error-msg'));
				})
			: getSubmitLeadAjaxRequest());
	};

	function getAvailableSubscriptions(division, category, subscriptionManagerIds) {
		var disableCode = 'fetchingAvailableSubscriptions',
			currentPage = document.createElement('a');

		currentPage.href = window.location.href;
		toggleSubmitBtn(false, disableCode);

		getAvailableSubsApi.ajax(leadEntityId
			? {
				url: "/api/spray/subscriptions/GetAllSubscriptionsForEntity",
				type: "POST",
				data: {
                    entityId: leadEntityId,
                    domain: currentPage.href
				},
				success: function(data) {
					populateSubscriptionCheckboxes(data.Subscriptions, true);
					$('#unsubscribe-all').prop('checked', data.GlobalUnsubscribe);
					$('#never-contact').prop('checked', data.DoNotContact);
					setGlobalSelectVisibility(data.Subscriptions);

					// populate lead info (firstname, lastname)
					$('#fname').val(data.FirstName);
					$('#lname').val(data.LastName);
					toggleSubmitBtn(true, disableCode);
                }
			}
			: {
				url: "/api/spray/subscriptions/GetAvailableSubscriptions",
				type: "POST",
				data: {
					domain: currentPage.href,
					division: division,
					category: category
				},
                success: function (subs) {
                    // filter subscriptions based on subscriptionManagerId if provided
					if (subscriptionManagerIds.length > 0) {
						subs = subs.filter(function(sub) {
							return subscriptionManagerIds.indexOf(
									sub.SubscriptionManagerId.toLowerCase()
								) > -1;
						});
					}

					populateSubscriptionCheckboxes(subs);
					setGlobalSelectVisibility(subs);
					toggleSubmitBtn(true, disableCode);
                }
			});
	}

	function setGlobalSelectVisibility(subscriptions) {
		// only show select/unselect all when multiple subscriptions are available
		if (!subscriptions || subscriptions.length <= 1) {
			$('#select-unselect-all-container').slideUp();
		} else {
			$('#select-unselect-all-container').slideDown();
		}
	}

	function populateSubscriptionCheckboxes(availableSubscriptions, isManagement) {
		// Dictionary that maps CategoryName to a category object.
		// An array is not used here to keep duplicates out of the set.
		// example { "CategoryName": {name: "CategoryName", enum: 1}, ...}
		var categories = {};

		// Populate categories{}
		for (var i = 0; i < availableSubscriptions.length; i++) {
			subscription = availableSubscriptions[i];
			categories[subscription.CategoryName] = {
				name: subscription.CategoryName,
				enum: subscription.Category
			};
		}

		// Clear old subscription options to make way for incoming options
		subscriptionsContainer.html('');

		// Iterate through categories, creating DOM structure to mirror pattern used in Forms
		//
		// <div class="category-container">
		//     <checkbox class="category-checkbox showhide" />...
		//     <div class="showhide-children reveal-if-checked subscription-options-container">
		//         <checkbox class="font-weight-normal" data-subscription-manager-id="GUID" data-category-enum="1" />...
		//     </div>
		// </div>
		//
		// Note: <checkbox /> is the encapsulation of a proper spray-form checkbox
		var indices = Object.keys(categories);
		for (var i = 0; i < indices.length; i++) {
			var category = categories[indices[i]];

			// create <div class="category-container">
			var section = createCategoryContainer(category.name, subscriptionsContainer[0]);

			// Populate category with all subscription options
			for (var j = 0; j < availableSubscriptions.length; j++) {
				var subscription = availableSubscriptions[j];
				if (subscription.Category != category.enum) {
					continue;
				}

				// create subscription checkboxes and attach metadata that can be parsed on submit
				var subOption = createCheckbox(subscription.Name, section.subOptionsContainer);
				subOption.checkbox.setAttribute('data-subscription-manager-id', subscription.SubscriptionManagerId);
				subOption.checkbox.setAttribute('name', 'spray-subscription');

				if (subscription.IsUserSubscribed || (availableSubscriptions.length === 1 && !isManagement)) {
					// expand category if a child is checked
					$(section.categoryContainer).find('.category-checkbox')
						.attr('checked', true);

					// pre-fill subscription checkbox
					$(subOption.checkbox)
						.attr('checked', true);

					// mark the checkbox if pre-fill is due to an already existing subscription
					if (subscription.IsUserSubscribed) {
						$(subOption.checkbox).attr('previous-value', true);
					}
				}
			}
		}
	}

	function getSubscriptionPreferences() {
		var subscriptionCheckboxes = $('.subscription-options-container input[type="checkbox"]'),
			preferences = [];

		// Construct subscription preferences
		for (var i = 0; i < subscriptionCheckboxes.length; i++) {
			var subCheckbox = subscriptionCheckboxes[i],
				subManagerId = $(subCheckbox).data('subscription-manager-id');

			// make sure checkbox has a subscription-manager-id associated with it.
			// note: This condition should never be met unless our JS or markup becomes invalid
			if (!subManagerId) {
				console.error(
					'selected subscription option does not have associated subscription-manager-id: '
					+ subCheckbox.id);
				continue;
			}

			// exclude preference if user has not made changes
			if (!!$(subCheckbox).attr('previous-value') == !!$(subCheckbox).prop('checked')) {
				continue;
			}

			// Add to dictionary of subscriptionManager Guids to checkbox value
			// example: {Key: GUID, Value: true}
			preferences.push({Key: subManagerId, Value: subCheckbox.checked});
		}

		return preferences;
	}

	function getSubmitLeadAjaxRequest() {
		var preferences = getSubscriptionPreferences();
		return {
			url: '/api/spray/subscriptions/SubmitLeadWithSubscriptionPreferences',
			type: 'POST',
			data: {
				lead: {
					FirstName: $('#fname').val(),
					LastName: $('#lname').val(),
					EmailAddress: $('#email').val(),
					AddressCountryCode: $('#country').val()
				},
				subscriptionPreferences: {
					Preferences: preferences,
					UnsubscribeAll: false,
					NeverContactAgain: false
				},
				leadSource: window.location.href,
				gdpr1: $('#gdpr-1')[0].checked,
			},
			success: function(data) {
				window.location.href = submitSuccessUrl;
			},
			error: function() {
				window.location.href = submitErrUrl;
			}
		};
	}

	function getSubmitPreferencesAjaxRequest(successCallback) {
		var isUnsubscribeAll = $('#unsubscribe-all').prop('checked'),
			isNeverContactAgain = $('#never-contact').prop('checked'),
			preferences = !isUnsubscribeAll && !isNeverContactAgain
				? getSubscriptionPreferences()
				: [];
		return {
			url: '/api/spray/subscriptions/SubmitPreferences',
			type: 'POST',
			data: {
				EntityId: leadEntityId,
				Preferences: preferences,
				UnsubscribeAll: isUnsubscribeAll,
				NeverContactAgain: isNeverContactAgain
			},
			success: function(data) {
				// re-enable button so user can continue managing subscriptions
                toggleSubmitBtn(true, 'form-submit');

				if (successCallback) {
					successCallback(data);
				}
			},
		};
	}

	function createCategoryContainer(categoryName, subscriptionsContainer) {
		var categoryContainerTemplate = $('#category-container-template').html(),
			categoryContainer = $(categoryContainerTemplate),
			checkbox = categoryContainer.find('input'),
			label = categoryContainer.find('label').text(categoryName),
			subOptionsContainer = categoryContainer.find('.subscription-options-container');

		$(subscriptionsContainer).append(categoryContainer);


		relateInputWithLabel(checkbox[0], label[0]);

		return {
			categoryContainer: categoryContainer[0],
			subOptionsContainer: subOptionsContainer[0]
		};
	}

	function createCheckbox(labelTxt, container) {
		var checkboxTemplate = $('#sub-checkbox-template').html(),
			field = $(checkboxTemplate),
			checkbox = $(field).filter('input'),
			label = $(field).filter('label').text(labelTxt);

		relateInputWithLabel(checkbox[0], label[0]);
		$(container).append(checkbox);
		$(container).append(label);

		return { checkbox: checkbox[0], label: label[0] };
	}

	function newInputLabelMapper() {
		var counter = 0;
		return function(checkbox, label) {
			var checkboxId = 'checkbox-id-' + ++counter;
			$(checkbox).prop('id', checkboxId);
			$(label).prop('for', checkboxId);
		}
	}

	function GetButtonToggleFn(btn) {
		var inhibitors = [];

		return function(callToEnable, inhibitor) {
			var inhibitorIndex = inhibitors.indexOf(inhibitor);

			// call to disable
			if (!callToEnable) {
				// add an inhibitor to prevent others from enabling button
				if (inhibitorIndex == -1) {
					inhibitors.push(inhibitor);
				}

				btn.setAttribute('disabled', 'disabled');
				return;
			}

			// call to enable
			// remove our inhibitor
			if (inhibitorIndex != -1) {
				inhibitors.splice(inhibitorIndex, 1);
			}

			// enable the button if no inhibitors left
			if (inhibitors.length == 0) {
				btn.removeAttribute('disabled');
			}
		}
	}

	function newMessageDisplayer(msgContainer) {
		var msgNumber = 0;

		return function(text, displayDuration) {
			var msgNum = ++msgNumber,
				timeoutCallback = null;

			if (displayDuration) {
				timeoutCallback = function() {
					setTimeout(function() {
						// hide msg container only based on the most recent call
						if (msgNum == msgNumber) {
							msgContainer.slideUp(350);
						}
					}, displayDuration);
				}
			}

			msgContainer.slideUp(350, function() {
				msgContainer.text(text).slideDown(350, timeoutCallback);
			});
		}
	}
});

function onloadRecaptchaCallback () {
	window.grecaptcha.render('recaptcha-container', {
		'sitekey': $('#recaptcha-container').data('recaptcha-key'),
        'callback': function(token) {
            $('#captcha-verifier').val('done');
        },
        'expired-callback': function (args) {
            $('#captcha-verifier').val('');
        }
    });
};
